import * as XLSX from 'xlsx';

/**
 * Converts a list of company objects into an Excel file and triggers download.
 * @param {Array} data List of company objects to be exported
 */
export function exportToExcel(data) {
  if (!data || !data.length) {
    console.error('No data available for export.');
    return;
  }

  // Define a map of user-friendly headers
  const headersMap = {
    companyName: 'Company Name',
    address: 'Address',
    contact: 'Contact Details',
    email: 'Email',
    website: 'Website',
    clientId: 'Client ID',
    consultant: 'Consultant',
    source: 'Source',
    status: 'Status',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    currentRecruitmentMethod: 'Current Recruitment Method',
    regEndDate: 'Registration End Date',
    companyRegNo: 'Company Registration No.',
    natureOfBusiness: 'Nature of Business',
  };

  // Prepare data for export
  const exportData = data.map(item => {
    const formattedItem = {};
    Object.keys(item).forEach(key => {
      if (key === '_id' || key === 'businessRecords' || key === 'subsidiaryRecords' || key === 'peopleRecords' || key === 'parentRecord') return; // Skip these fields

      if (headersMap[key]) {
        const value = item[key];

        // Format dates to a readable format
        if (value && new Date(value).toString() !== 'Invalid Date' && typeof value === 'string' && value.includes('T')) {
          formattedItem[headersMap[key]] = new Date(value).toLocaleDateString();
        } else if (key === 'address' && typeof value === 'object') {
          formattedItem[headersMap[key]] = `${value.addressLine1}, ${value.addressLine2}, ${value.addressLine3}, ${value.town}, ${value.county}, ${value.country}, ${value.postcode}`;
        } else if (key === 'contact' && typeof value === 'object') {
          formattedItem[headersMap[key]] = `${value.office ? `Office: ${value.office}` : ''}`;
        } else {
          formattedItem[headersMap[key]] = value;
        }
      }
    });

    return formattedItem;
  });

  // Create worksheet and workbook
  const worksheet = XLSX.utils.json_to_sheet(exportData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Exported Company Data');

  // Trigger file download
  XLSX.writeFile(workbook, 'exported_company_data.xlsx');
}
